import { isAuthenticatedUser } from 'js/lib/user';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import { useOnboardingQuestionData } from 'bundles/onboarding-common/contexts/OnboardingQuestionDataContext';
import useGetLearnerObjectPromise from 'bundles/onboarding-common/hooks/useGetLearnerObjectPromise';
import useUpdateDesiredSkills from 'bundles/onboarding-common/hooks/useUpdateDesiredSkills';
import { updateLocalStorageOnboardingData } from 'bundles/onboarding-common/utils/localStorageUtils';

const useSubmitAnswer = () => {
  const { updateDesiredSkills } = useUpdateDesiredSkills();
  const { questionValue, setQuestionValue, submitAnswerOptions } = useOnboardingQuestionData();
  const { getLearnerObjectPromise } = useGetLearnerObjectPromise();

  const isUnregisteredUser = !isAuthenticatedUser();
  const shouldClearSavedSkills = submitAnswerOptions?.shouldClearSavedSkills;

  const promise = async () => {
    if (isUnregisteredUser) {
      if (!questionValue) {
        return Promise.resolve();
      }
      const clearSavedSkills = shouldClearSavedSkills
        ? { [QUESTION_IDS.skillSelect]: { __typename: QUESTION_IDS.skillSelect, value: [] } }
        : {};
      return updateLocalStorageOnboardingData({ [questionValue?.__typename]: questionValue, ...clearSavedSkills });
    }

    if (shouldClearSavedSkills) {
      await updateDesiredSkills(null, true);
    }

    return getLearnerObjectPromise({ questionValue });
  };

  const submitAnswer = async () => {
    if (questionValue) {
      await promise();

      setQuestionValue(null);
    }
  };

  return { submitAnswer };
};

export default useSubmitAnswer;
